import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  category: "",
  product: "",
  manual: "",
};

export const sideMenuSlice = createSlice({
  name: "sideMenuChecker",
  initialState,
  reducers: {
    setSideMenuReducer: (state, action) => {
      state.category = action.payload.category;
      state.product = action.payload.product;
      state.manual = action.payload.manual;
    },
  },
});

export const { setSideMenuReducer } = sideMenuSlice.actions;

export default sideMenuSlice.reducer;
